export class JobTokenPayload {
    public jobID: number = 0;
    public token: string = '';
}